/**
 * Created by brianschroer on 3/15/16.
 */

(function () {
    'use strict';

    // @ngInject
    function TrialExpiringControllerCtor($scope, $injector, $modalInstance, $state,
                                         AnalyticsService, AppStates, UsersManager, ModalService,
                                         trialExpiredOnNewSession, OnboardingService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TrialExpiringController';
        this.$state = $state;
        this.AppStates = AppStates;
        this.ModalService = ModalService;
        this.trialExpiredOnNewSession = trialExpiredOnNewSession;
        this.AnalyticsService = AnalyticsService;

        this.currUser = UsersManager.getCurrUser();
        this.isCompanyOwner = this.currUser.isCompanyOwner();
        this.membershipCanceled = this.currUser.company.membership_canceled;

        AnalyticsService.trackPageView(this, 'TrialExpiringView');

        this.$modalInstance = $modalInstance;
        if (this.trialExpiredOnNewSession) {
            this.analyticsEvent = 'sign me up, trial expired on new session modal';
        } else {
            this.analyticsEvent = 'sign me up, create event modal';
        }
    }

    Controllers.TrialExpiringController = Class(Controllers.BaseController, {
        constructor: TrialExpiringControllerCtor,

        close: function close() {
            this.$modalInstance.dismiss('cancel');
        },

        onSignMeUp: function onSignMeUp() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action, {
                unique: 'membership page',
                source: 'trial expired modal',
                trial_days_left: 0
            });

            if (this.currUser.isVenueVendor()) {
                this.ModalService.openVenuesUpgradeNowModal();
            } else {
                this.$state.go(this.AppStates.root_core_navigation_settings_companySettings_subscription);
            }
            this.$modalInstance.close();
        }
    });
}());
